import { Text, View } from '@react-pdf/renderer';
import logo from '@ui/assets/images/GRE/GRE_FOX_VALLY_RGB_PRIMARY_LOGO_AW.png';
import { EnvConfig } from '@ui/config/env';

import { usePDFContext } from '../PDFProvider';
import { EmployeeInformation } from './components/EmployeeInformation';
import { Header } from './components/Header';
import { Logo } from './components/Logo';
import { Page } from './components/Page';
import { CustomerAddress } from './components/QuoteDetails/CustomerAddress';
import { CustomerContact } from './components/QuoteDetails/CustomerContact';
import { QuoteDetails } from './components/QuoteDetails/QuoteDetails';
import { QuoteInformation } from './components/QuoteDetails/QuoteInformation';
import { QuoteId } from './components/QuoteId';
import { QuoteLineForPart, QuoteLineForServices } from './components/QuoteLine';
import { PartDescription } from './components/QuoteLine/PartDescription';
import { PartId } from './components/QuoteLine/PartId';
import { PartSpecs } from './components/QuoteLine/PartSpecs';
import { SiteInformation } from './components/SiteInformation';
import { Specs } from './components/Specs';
import { styles } from './components/styles';

const GRE_SITE_INFORMATION = [
  'N915 Craftsmen Drive',
  'Greenville WI, 54942',
  'Ph (920) 757-7777',
  'Fx (920) 757-8888',
];

export function GREQuoteDocument() {
  const { quoteLines } = usePDFContext();

  return (
    <Page>
      <Header>
        <Logo
          source={logo}
          text="ISO 9001:2015 Registered"
          extraStyles={[{ height: '39px' }]}
        />

        <SiteInformation
          name="Fox Valley Spring"
          items={GRE_SITE_INFORMATION}
        />

        {/* Some sites may have a different ecommerce site */}
        <QuoteId ecommerceUri={EnvConfig.getKey('MW_COMPONENTS_URI')} />
      </Header>

      <QuoteDetails>
        <CustomerAddress />

        <CustomerContact />

        <QuoteInformation />
      </QuoteDetails>

      {quoteLines.map((line) => {
        const { part, ...lineProps } = line;
        if (!part) {
          return <QuoteLineForServices {...line} showDescription />;
        }
        return (
          <QuoteLineForPart
            key={line.id}
            {...lineProps}
            part={part}
            showDrawing
          >
            <PartId part={part} />

            <PartDescription description={part.description} />

            <PartSpecs specs={line.specs} />
          </QuoteLineForPart>
        );
      })}

      <Specs />

      <EmployeeInformation />

      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={[styles.bold, styles.textSmall]}>
            Due to variables in production and finishing methods, we reserve the
            right to over or under ship a maximum of 5% on confirmed shipment
            quantities. Any defective material claims must be made within thirty
            (30) days of shipment. If the claim is sustained, seller reserves
            the right to remanufacure defective material or refund the cost of
            the defective parts with no further action allowable by purchaser.
            All dimensions, if not specifically toleranced, will be held to SMI
            tolerances, and not held to any generic block drawing tolerance.
            Cancellations shall be subject to seller’s confirmation as well as
            receipt of costs generated in good faith to fulfill customer’s
            orders. If quantity is lowered, we reserve the right to increase the
            unit cost. Seller is indemnified against liability for patent
            infringement, misuse of product, or use in purchaser’s application.
            Issuance of purchase order by purchaser will be considered
            acceptance of all prior conditions.
          </Text>
          <Text>{'\n'}</Text>
          <Text>
            Standard terms and conditions can be found on www.mwcomponents.com
            &lt;https://www.mwcomponents.com/mw-industries-terms-and-conditions&gt;
          </Text>
        </View>
      </View>
    </Page>
  );
}
